import { useQuery } from '@tanstack/react-query'
import axios from 'axios'

// Remove subdomain for ems.rfdme.io domains
const getMainDomain = (host) => {
    if (host === 'localhost') {
        return 'ems.rfdme.io'
    }
    // Check if it's a subdomain of ems.rfdme.io
    if (host.endsWith('.ems.rfdme.io')) {
        return 'ems.rfdme.io'
    }
    return host
}

const useCustomerSettings = () => {
    const hostname = typeof window !== 'undefined' ? window.location.hostname : ''
    
    const id = getMainDomain(hostname)
    const type = 'domain'
    const { data: customerSettings, ...arg } = useQuery({
        queryKey: ['getCustomerSettings', {id, type}],
        queryFn: async ({ queryKey }) => {
            try {
                const response = await axios({
                    method: 'POST',
                    // eslint-disable-next-line no-undef
                    url: `${process.env.REACT_APP_APIGATEWAY_URL}/vpp/profile/query`,
                    data: {
                        formData: {
                            id: queryKey[1].id,
                            type: queryKey[1].type,
                        }
                    },
                })
                
                // 確保返回值不是 undefined
                const result = response?.data?.data
                if (result === undefined) {
                    console.warn('getCustomerSettings: API 返回 undefined，使用空物件', response?.data)
                    return {} // 返回空物件而不是 undefined
                }
                
                return result // Response received from the API
            } catch (error) {
                console.error('getCustomerSettings error:', error)
                return await Promise.reject(error)
            }
        },
        enabled: !!id && !!type,
    })

    return { customerSettings, ...arg }
}

export default useCustomerSettings
